<template lang="pug">
.v-page-section-links.page-section-links(v-if="section" )
	template(v-if="section.items" )
		.page-section-links__card.card-horiz.flc(v-for="(card, index) in section.items" :class="card.className" :key="index" )
			template(v-if="card.image" )
				img.card-horiz__img(
					:src="card.image?.src"
					:alt="card.image?.alt")
			.card-horiz__links(v-if="card.links" )
				h3.card-horiz__links-title(v-if="card.links.title" ) {{ card.links.title }}
				ul.card-horiz__links-list
					li.card-horiz__links-item(v-for="(link, index) in card.links.items" :key="index" )
						a.card-horiz__link(:href="link?.link") {{ link.text }}
	img.page-section-banner(v-if="section.banner" :src="section.banner.src" :alt="section.banner.alt")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [sourceMixin],

	data() {
		return {
			section: null
		};
	},

	methods: {
		dataSet(data) {
			this.section = data;
		}
	}
};
</script>